import { z } from 'zod';

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const HHMM_RE = /^([01]?\d|2[0-3]):[0-5]\d$/;

export const timesheetEntryInputSchema = z.object({
  colaboradorCodigo: z.number().int().positive('Obrigatório'),
  clienteCodigo: z.number().int().positive('Obrigatório'),
  clienteProjetoCodigo: z.number().int().positive('Obrigatório'),
  tipoTarefaCodigo: z.number().int().positive('Obrigatório'),
  tipoHoraCodigo: z.number().int().positive('Obrigatório'),
  data: z
    .string()
    .trim()
    .min(1, 'Obrigatório')
    .regex(ISO_DATE_RE, 'Formato inválido. Use AAAA-MM-DD.'),
  horas: z
    .string()
    .trim()
    .min(1, 'Obrigatório')
    .regex(HHMM_RE, 'Formato inválido. Use HH:MM (00:01 a 23:59).')
    .refine((s) => s !== '00:00', 'Deve ser maior que 00:00.'),
  atividade: z.string().trim().min(1, 'Obrigatório').max(2000, 'Máximo 2000 caracteres'),
  codigoExterno: z.string().trim().max(60, 'Máximo 60 caracteres').nullable().optional(),
});

export type TimesheetEntryFormValues = z.input<typeof timesheetEntryInputSchema>;
